module.exports = __webpack_public_path__ + "static/media/delete-tool-white.88bf18af.svg";